import { a as _objectWithoutProperties, k as _objectSpread2, e as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-6a814b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import { s as styleInject } from '../style-inject.es-a0e1a0ba.js';
import cx from 'classnames';
import { makeQAAttributes } from '../utils/qaAttributes.js';

var css_248z = ".icon_2i2UD4{display:inline-block;vertical-align:middle;color:inherit;line-height:0;fill:currentColor;pointer-events:none}.icon_2i2UD4>svg{width:100%;height:100%}.width-12_1rdsGn{width:.75em}.width-16_2IZ_cG{width:1em}.width-24_21vUQw{width:1.5em}.width-32_1QPIW3{width:2em}.width-36_1Z5xy_{width:2.25em}.width-42_3Xr1z6{width:2.625em}.width-44_39ls3x{width:2.75em}.width-48_2dUCQZ{width:3em}.width-56_1FR3_9{width:3.5em}.height-12_3wd3Of{height:.75em}.height-16_1-rLeg{height:1em}.height-24_1_5SCG{height:1.5em}.height-32_3RLmWM{height:2em}.height-36_3Ku9wK{height:2.25em}.height-42_39Qun5{height:2.625em}.height-44_6yGnzK{height:2.75em}.height-48_3xgF1V{height:3em}.height-56_GVAUQC{height:3.5em}.color-4a90e2_3V577n{color:#4a90e2!important}.color-ff9000_VAUm8B{color:#ff9000!important}.color-666_1rb3Xe{color:#666!important}.color-3bb273_u6VHhj{color:#3bb273!important}";
var styles = {"icon":"icon_2i2UD4","width-12":"width-12_1rdsGn","width-16":"width-16_2IZ_cG","width-24":"width-24_21vUQw","width-32":"width-32_1QPIW3","width-36":"width-36_1Z5xy_","width-42":"width-42_3Xr1z6","width-44":"width-44_39ls3x","width-48":"width-48_2dUCQZ","width-56":"width-56_1FR3_9","height-12":"height-12_3wd3Of","height-16":"height-16_1-rLeg","height-24":"height-24_1_5SCG","height-32":"height-32_3RLmWM","height-36":"height-36_3Ku9wK","height-42":"height-42_39Qun5","height-44":"height-44_6yGnzK","height-48":"height-48_3xgF1V","height-56":"height-56_GVAUQC","color-4a90e2":"color-4a90e2_3V577n","color-ff9000":"color-ff9000_VAUm8B","color-666":"color-666_1rb3Xe","color-3bb273":"color-3bb273_u6VHhj"};
styleInject(css_248z);

var Icon = function Icon(_ref) {
  var _cx;

  var css = _ref.css,
      symbol = _ref.symbol,
      props = _objectWithoutProperties(_ref, ["css", "symbol"]);

  var mergedCSS = _objectSpread2({}, Icon.defaultProps.css, {}, css);

  var width = mergedCSS.width,
      height = mergedCSS.height,
      color = mergedCSS.color;
  var componentClassName = cx(styles.icon, (_cx = {}, _defineProperty(_cx, styles["color-".concat(color)], color), _defineProperty(_cx, styles["width-".concat(width)], width), _defineProperty(_cx, styles["height-".concat(height)], height), _cx));
  return /*#__PURE__*/React.createElement("span", _extends({
    className: componentClassName,
    "aria-hidden": "true"
  }, props), symbol);
};

Icon.propTypes = {
  css: PropTypes.shape({
    /** '4a90e2', 'ff9000' */
    color: PropTypes.oneOf(['4a90e2', 'ff9000', '666', 'bb273']),

    /** 12, 16, 24, 32, 44, 48 */
    width: PropTypes.oneOf([12, 16, 24, 32, 44, 48, 56]),

    /** 12, 16, 24, 32, 44, 48 */
    height: PropTypes.oneOf([12, 16, 24, 32, 44, 48, 56])
  }),
  symbol: PropTypes.element.isRequired
};
Icon.defaultProps = _objectSpread2({
  css: {
    color: null,
    width: 16,
    height: 16
  }
}, makeQAAttributes('icon'));

export default Icon;
//# sourceMappingURL=Icon.js.map
